<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="project-receive-server-table"
      class="w-100"
    >
      <div slot="beforeTable">
        <b-row>
          <!-- <b-col class="pr-0">
            <select-filter
              variant="info"
              icon="fa fa-user"
              placeholder="Select a Customer"
              :collection="customer_filters"
              value-key="id"
              text-key="full_name"
              filter-field="customer.id"
              filter-operator="eq"
              @onSelect="setCustomFilter('customer', $event)"
            />
          </b-col> -->
          <b-col class="pr-0">
            <select-filter
              variant="info"
              icon="fa fa-tags"
              placeholder="Select a Sample Type"
              :collection="sample_type_filters"
              value-key="id"
              text-key="name"
              filter-field="submissions.sample_type.id"
              filter-operator="eq"
              @onSelect="setCustomFilter('sample_type', $event)"
            />
          </b-col>
          <b-col>
            <div style="margin-top: 0.75rem;">
              <date-filter
                prefix="Creation Date"
                filter_field="created_at"
                filter_operator="eq"
                @onSelect="setDateFilter('creation_date', $event)"
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <span slot="submission" slot-scope="{ row }">
        <router-link :to="`/submissions/${row.id}`">
          {{ row.publicNumber() }}
        </router-link>
      </span>
      <span slot="project" slot-scope="{ row }">
        <router-link :to="`/projects/${row.project_id}`">
          {{ row.getProject().publicNumber() }}
        </router-link>
      </span>
      <span slot="project.customer.full_name" slot-scope="{ row }">
        <existence-gate :entity="row.getProject()" :levels="['customer']" :field="'name'">
          <template #existing-content>
            <router-link
              :to="`/customer/${getData(row.getProject(), {
                levels: ['customer'],
                field: 'id',
              })}`"
            >
              {{ getData(row.getProject(), { levels: ["customer"], field: "short_name" }) }}
            </router-link>
          </template>
        </existence-gate>
      </span>
      <span slot="sample_type" slot-scope="{ row }">
        <router-link :to="`/sampletypes/${row.getSampleType().id}`">
          {{ row.getSampleType().name }}
        </router-link>
      </span>
      <span slot="test_package" slot-scope="{ row }">
        <router-link :to="`/testpackages/${row.test_package.id}`">{{
          row.test_package.name
        }}</router-link>
      </span>
      <span slot="samples" slot-scope="{ row }">
        
         <template v-if="row.getSamples().models.length > 3">
          <span
            v-for="(sample, sample_index) in row.getSamples().models.slice(0, 2)"
            :key="sample_index"
          >
            <router-link :to="`/samples/${sample.id}`">{{
              sample.publicNumber()
            }}</router-link
            >,
          </span>
          <router-link :to="`/submissions/${row.id}`">
            <b>...</b>
          </router-link>
        </template>
        <template v-else>
          <span
            v-for="(sample, sample_index) in row.getSamples().models"
            :key="sample_index"
          >
            <router-link :to="`/samples/${sample.id}`">{{
              sample.publicNumber()
            }}</router-link>
            <span v-if="sample_index != row.getSamples().length - 1"
              >,
            </span>
          </span>
        </template>
      </span>
      <span slot="received" slot-scope="{ row }">
        <sample-received-bar
          class="d-inline-block w-100"
          :samples="row.getSamples()"
        />
      </span>
      <span slot="created_at" slot-scope="{ row }">
        {{ row.created_at | moment("L") }}
      </span>
      
      <span slot="actions" slot-scope="{ row }">
        <b-row>
          <b-col class="pr-0 pl-3">
            <a
              class="btn btn-success px-1 py-0 text-white mr-1"
              v-if="isInReceiveStore(row.id)"
              @click="handleListChange(row, 'remove')"
            >
              <i class="fa fa-check-square" />
            </a>
            <a
              v-else
              class="btn btn-info px-1 py-0 text-white mr-1"
              @click="handleListChange(row, 'add')"
            >
              <i class="fa fa-square" />
            </a>
          </b-col>
          <b-col class="pl-0">
            <a
              @click="handleListChange(row, 'add')"
              class="btn btn-info btn-block px-1 py-0 text-white mr-1"
              :href="'#/samples/receive/batch'"
            >
              <i class="fa fa-caret-right" />
            </a>
          </b-col>
        </b-row>
      </span>
      <b-row slot="afterTable" class="pr-3 mb-5" align-h="end">
        <b-col md="1.5" class="ml-2">
          <b-button
            variant="info"
            class="text-white"
            :disabled="!Boolean(receiveList.length)"
            @click="RECEIVE_REMOVE_ALL()"
            block
            >Clear All</b-button
          >
        </b-col>
        <b-col md="1.5" class="ml-2">
          <b-button
            variant="success"
            :disabled="!Boolean(receiveList.length)"
            :href="'#/samples/receive/batch'"
            block
          >
            <i class="fa fa-check-square" /> Receive Selected
          </b-button>
        </b-col>
      </b-row>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import SampleReceivedBar from "./SampleReceivedBar";
import BaseServerTable from "@/components/shared/BaseServerTable";
import DateFilter from "@/components/shared/DateFilter";
import ExistenceGate from "@/components/shared/ExistenceGate";
import SelectFilter from "@/components/shared/SelectFilter";
import SubmissionCollection from "@/collections/lab/SubmissionCollection";
import SelectButton from "@/external/schedulewizard/components/SelectButton";
import { mapActions, mapGetters } from "vuex";
import { ServerTable } from "vue-tables-2";
import { getCollection } from "@/shared/fetch-utils";
import { getEntityData } from "@/shared/utils";

Vue.use(ServerTable);

export default {
  name: "ProjectReceiveServerTable",
  extends: BaseServerTable,
  components: {
    ExistenceGate,
    SampleReceivedBar,
    ServerTable,
    SelectButton,
    SelectFilter,
    DateFilter,
  },
  props: {
    collection: {
      type: Object,
      default: () => new SubmissionCollection(),
    },
    sample_types: {
      type: Object,
      default: () => null,
    },
    show_columns: {
      type: Array,
      default: () => [
        "submission",
        "project",
        "project.customer.full_name",
        "sample_type",
        "test_package",
        "samples",
        "received",
        "created_at",
        "actions",
      ],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => ["project.customer.full_name", "created_at"],
    },
  },
  data() {
    return {
      customer_collection: null,
      sample_type_collection: null,
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headings: {
            submission: "Submission",
            test_package: "Test Package",
            sample_type: "Sample type",
            created_at: "Date",
            samples: "Sample(s) expected",
            "project.customer.full_name": "Customer"
          },
          filterable: this.filterable,
          sortable: this.sortable,
        },
      }),
    };
  },
  computed: {
    ...mapGetters({
      receiveList: "receiveStore",
    }),
    customer_filters() {
      return this.customer_collection;
    },
    sample_type_filters() {
      return this.sample_types || this.sample_type_collection;
    },
  },
  methods: {
    ...mapActions(["RECEIVE_ADD", "RECEIVE_REMOVE", "RECEIVE_REMOVE_ALL"]),
    getData({ _reference }, data) {
      return getEntityData({
        entity: _reference,
        ...data,
      });
    },
    isInReceiveStore(id) {
      return this.receiveList.find((item) => item.id === id);
    },
    handleListChange(sample, action) {
      if (action === "add") {
        this.RECEIVE_ADD(sample);
      } else {
        this.RECEIVE_REMOVE(sample.id);
      }
    },
    //#TODO: handle  >= date <= filter
    setDateFilter(key, filter) {      
      this.setCustomFilter(key, filter);
    },
    async init() {
      !this.sample_types &&
        (this.sample_type_collection = await getCollection({
          collection_type: "sample_type",
          limit: "all",
          message: this.$bvToast,
        }));

        this.customer_collection = await getCollection({
        collection_type: "submission",
        connections: ["project", "project.customer"],
        filters: [
          {
            logic: "filterNull",
            field: "samples.receiving_id",
          },
        ],
        sort: [
          {
            logic: "sortAddAsc",
            field: "created_at"
          },
        ],
        message: this.$bvToast,
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
